import AuthZeroErrorMessage from './component.jsx'
export default AuthZeroErrorMessage



// WEBPACK FOOTER //
// ./src/components/AuthZeroErrorMessage/index.js